import { render, staticRenderFns } from "./report-title.vue?vue&type=template&id=4571c20e&scoped=true"
import script from "./report-title.vue?vue&type=script&lang=js"
export * from "./report-title.vue?vue&type=script&lang=js"
import style0 from "./report-title.vue?vue&type=style&index=0&id=4571c20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571c20e",
  null
  
)

export default component.exports